module.exports = __webpack_public_path__ + "img/zijinliushui_zuo.a6781520.png";